import { makeAutoObservable } from "mobx";

import { cmpScalarValues } from "../../../../../common/cmpScalarValues";
import { MdmCardFormStore } from "../MdmCardFormStore";
import { FormField } from "./MdmCardFormTypes";
import { ZExprBool } from "./metaExpr";

type BoolResult = {
  readonly value: boolean;
};

// TODO: дублирование функциональности в form.calcBoolExpr
export const createBoolResult = (
  expr: ZExprBool,
  field: FormField | null,
  form: MdmCardFormStore,
): BoolResult | null => {
  let res: BoolResult | null = null;
  switch (expr.type) {
    case "true":
      res = { value: true };
      break;
    case "boolField":
      res = {
        get value(): boolean {
          return !!form.calcExprValue(expr.path, field);
        },
      };
      break;
    case "fieldValue":
      res = {
        get value(): boolean {
          const leftValue = form.calcExprValue(expr.path, field);
          return !!cmpScalarValues(expr.op, leftValue, expr.value);
        },
      };
      break;
    default:
      break;
  }
  return res ? makeAutoObservable(res) : null;
};

// export const calcBoolExpr = (
//   expr: ZExprBool,
//   field: FormField | null,
//   form: MdmCardFormStore,
// ): boolean => {
//   let result: boolean = false;
//   switch (expr.type) {
//     case "true":
//       result = true;
//       break;
//     case "boolField":
//       result = !!form.calcExprValue(expr.path, field);
//       break;
//     default:
//       break;
//   }
//   return result;
// };
